<template>
    <tr class="c-tr">
        <td @click="editItem">{{ data.widget_id }}</td>
        <td @click="editItem">{{ data.name }}</td>
        <td @click="editItem">{{ data.type_name }}</td>
        <td @click="editItem">{{ data.campaign_title }}</td>
        <td @click="editItem">
            {{ data.viewed }} > {{ data.engaged }} > {{ data.completed }}
        </td>
        <td>
            <div class="dropdown-btn" v-if="DibbleJS.isAllowedAccess(Authorizations.MODULE_NAMES.WIDGET_MANAGEMENT_EDIT)">
                <a>
                    <img src="~@/assets/images/blue-bar.svg"
                         @click="showAction"
                         alt="">
                </a>
                <div v-if="isShowAction" class="dropdown-menu"
                     :class="isShowAction ? 'active' : ''"
                     style="right: 80px; top: 15px; z-index: 99999"
                     v-click-outside="
                        () => {
                                hideAction();
                            }
                        "
                >
                    <a class="dropdown-item"
                       href="javascript:;"
                       @click="cloneItem"
                       v-text="'Clone'"></a>
                    <a v-if="!isArchived" class="dropdown-item"
                       href="javascript:;"
                       @click="archiveItem"
                       v-text="'Archive'"></a>
                    <a v-if="isArchived" class="dropdown-item"
                       href="javascript:;"
                       @click="unarchiveItem"
                       v-text="'Unarchive'"></a>
                </div>
            </div>
        </td>
    </tr>
</template>

<script>
import DibbleJS from "@/dibble";
import DibbleApi from "@/api";
import Authorizations from "@/utils/authorizations";

export default {
    name: 'TableItem',
    computed: {
        DibbleJS() {
            return DibbleJS
        },
        Authorizations() {
            return Authorizations
        }
    },
    props: {
        data: Object,
        isArchived: Boolean
    },
    data() {
        return {
            isShowAction: false,
        }
    },
    methods: {
        cloneItem() {
            this.hideAction()
            this.$emit('clone', this.data)
        },
        archiveItem() {
            this.hideAction()
            DibbleJS.confirmBox('Are you sure you want to archive this widget?', () => {
                DibbleJS.showLoader()
                DibbleJS.callApiRequest({
                    '#request': DibbleApi.api.widgetSetStatus,
                    widget_id: this.data.widget_id,
                    status: 2
                }, response => {
                    DibbleJS.hideLoader();
                    if (DibbleApi.isResponseSuccess(response)) {
                        DibbleJS.toastSuccessMessage('Widget archived successfully');
                        this.$emit('refresh');
                    } else {
                        DibbleJS.toastErrorMessage(response.message)
                    }
                })
            })
        },
        unarchiveItem() {
            this.hideAction()
            DibbleJS.confirmBox('Are you sure you want to unarchive this widget?', () => {
                DibbleJS.showLoader()
                DibbleJS.callApiRequest({
                    '#request': DibbleApi.api.widgetSetStatus,
                    widget_id: this.data.widget_id,
                    status: 1
                }, response => {
                    DibbleJS.hideLoader();
                    if (DibbleApi.isResponseSuccess(response)) {
                        DibbleJS.toastSuccessMessage('Widget unarchived successfully');
                        this.$emit('refresh');
                    } else {
                        DibbleJS.toastErrorMessage(response.message)
                    }
                })
            })
        },
        editItem() {
            this.$emit('edit', this.data)
        },
        showAction() {
            this.isShowAction = true;
        },
        hideAction() {
            this.isShowAction = false;
        }
    },
};
</script>

<style lang="scss" scoped>
.c-tr {
    td {
        color: #7c7c7a;
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;
        cursor: pointer;

        &:first-child {
            min-width: 200px;
        }
    }
}
.dropdown-btn {
    position: relative;

    span {
        display: block;

        &.top {
            font-size: 12px;
            line-height: 16px;
            color: #555E67;
        }
    }

    .dropdown-menu {
        position: absolute;
        top: 100%;
        left: auto;
        right: 100px;
        z-index: 1000;
        display: none;
        min-width: 10rem;
        text-align: left;
        list-style: none;

        background-clip: padding-box;
        border: none;
        border-radius: 30px;
        width: 175px;
        background: none;

        &.active {
            display: block;
        }

        .dropdown-item {
            color: #555E67;
            font-size: 20px;
            font-weight: 700;
            background-color: #EDF5F7;
            padding: 12px 35px;
            border-bottom: 1px solid #DEE6EA;

            &:first-child {
                border-top-left-radius: 20px;
                border-top-right-radius: 20px;
            }

            &:last-child {
                border-bottom-left-radius: 30px;
                border-bottom-right-radius: 30px;
                box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
            }

            &:hover {
                background-color: #bae3ef;
                color: #2178AB;
            }
        }
    }
}
</style>
